import { render, staticRenderFns } from "./LearningActivityStat.vue?vue&type=template&id=33c9d88a&scoped=true&"
import script from "./LearningActivityStat.vue?vue&type=script&lang=js&"
export * from "./LearningActivityStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c9d88a",
  null
  
)

export default component.exports